module.exports = __webpack_public_path__ + "img/tutorial_war_07.15063b2a.gif";